import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Buildings } from "@phosphor-icons/react";

const KEY = "empresa_ativa_id";
export const getEmpresaAtiva = () => localStorage.getItem(KEY) || "";
export const useEmpresaAtiva = () => {
  const [id, setId] = useState(getEmpresaAtiva());
  useEffect(() => {
    const h = () => setId(getEmpresaAtiva());
    window.addEventListener("empresa-ativa", h);
    return () => window.removeEventListener("empresa-ativa", h);
  }, []);
  return id;
};
// Filtra listas no cliente pela empresa ativa ("" = todo o grupo). Registros sem vínculo só aparecem se `incluirSemVinculo`.
export const filtrarPorEmpresa = (lista, empresaId, incluirSemVinculo = false) =>
  (!empresaId ? lista : lista.filter((x) => x.empresa_executora_id === empresaId || (incluirSemVinculo && !x.empresa_executora_id)));

// Hook: aplica o filtro da entidade ativa e expõe o toggle de "sem vínculo".
export const useFiltroEmpresa = (lista) => {
  const ativa = useEmpresaAtiva();
  const [incluirSemVinculo, setIncluirSemVinculo] = useState(false);
  const semVinculo = ativa ? lista.filter((x) => !x.empresa_executora_id).length : 0;
  return { ativa, lista: filtrarPorEmpresa(lista, ativa, incluirSemVinculo), semVinculo, incluirSemVinculo, setIncluirSemVinculo };
};

export function SemVinculoToggle({ filtro, rotulo = "registro(s)" }) {
  if (!filtro.ativa || !filtro.semVinculo) return null;
  return (
    <button className="chip" onClick={() => filtro.setIncluirSemVinculo(!filtro.incluirSemVinculo)} data-testid="toggle-sem-vinculo"
      style={{ cursor: "pointer", background: filtro.incluirSemVinculo ? "#FFFBEA" : undefined, border: "1px dashed #B45309", color: "#B45309" }}
      title="Registros ainda não vinculados a nenhuma entidade (vincule em Migração Multiempresa)">
      {filtro.incluirSemVinculo ? "Ocultar" : "Mostrar"} {filtro.semVinculo} {rotulo} sem entidade
    </button>
  );
}

export function EmpresaSelector() {
  const [empresas, setEmpresas] = useState([]);
  const ativa = useEmpresaAtiva();
  useEffect(() => { api.get("/empresas").then((r) => setEmpresas(r.data.filter((e) => e.ativo !== false))).catch(() => {}); }, []);
  if (!empresas.length) return null;
  const mudar = (v) => { if (v) localStorage.setItem(KEY, v); else localStorage.removeItem(KEY); window.dispatchEvent(new Event("empresa-ativa")); };
  return (
    <div style={{ padding: "8px 12px 4px" }} data-testid="empresa-selector">
      <div className="overline" style={{ color: "#A1A1AA", display: "flex", alignItems: "center", gap: 4 }}><Buildings size={11} /> Entidade</div>
      <select className="select" style={{ fontSize: "0.75rem", height: 30, background: "#1C1917", color: "#fff", border: "1px solid #3F3F46" }} value={ativa} onChange={(e) => mudar(e.target.value)} data-testid="empresa-selector-select">
        <option value="">Todo o grupo</option>
        {empresas.map((e) => <option key={e.id} value={e.id}>{e.tipo === "consorcio" ? "Consórcio · " : ""}{e.nome}</option>)}
      </select>
    </div>
  );
}
